import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/AuthContext'
import { supabase } from '@/lib/supabase'

/**
 * Hook to check if the current user is a moderator or admin (has moderator+ permissions).
 * Checks both `role` and `user_type` in profiles. user_type = 'admin' or role = 'admin'
 * is a superuser and has all permissions (including moderator).
 */
export function useModerator() {
  const { user } = useAuth()

  const { data: isModerator } = useQuery({
    queryKey: ['is-moderator', user?.id],
    queryFn: async () => {
      if (!user) return false

      const { data, error } = await supabase
        .from('profiles')
        .select('role, user_type')
        .eq('id', user.id)
        .maybeSingle()

      if (error) {
        console.warn('Error checking moderator status:', error)
        return false
      }
      if (!data) return false

      const role = data?.role
      const userType = data?.user_type

      return (
        role === 'moderator' ||
        role === 'admin' ||
        userType === 'moderator' ||
        userType === 'admin'
      )
    },
    enabled: !!user,
    staleTime: 60000, // Cache for 1 minute
  })

  return isModerator ?? false
}

